// DS: MO5.1
import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import React from 'react';
import c from 'classnames';
import PlainButtonOrLink from '../PlainButtonOrLink';
import s from './ExclusiveButton.scss';
const ExclusiveButton = (_param)=>{
    var { className, priority, children, disabled, compact } = _param, props = _object_without_properties(_param, [
        "className",
        "priority",
        "children",
        "disabled",
        "compact"
    ]);
    return /*#__PURE__*/ React.createElement(PlainButtonOrLink, _object_spread({
        className: c(className, s['root'], s[`priority-${priority}`], disabled && s['disabled'], compact && s['compact']),
        disabled: disabled
    }, props), children);
};
ExclusiveButton.displayName = 'ExclusiveButton';
export default ExclusiveButton;

//# sourceMappingURL=ExclusiveButton.js.map